import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import PageHome from "containers/PageHome/PageHome";
import Header from "shared/Header/Header";
import Page404 from "containers/Page404/Page404";
import PageLogin from "containers/PageLogin/PageLogin";
import PageProfile from "containers/PageProfile/PageProfile";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "functions/redux/store";
import { getFullCreds, LOGIN_FALSE } from "functions/redux/user/action";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageJoinPartner from "containers/PageJoinPartner/PageJoinPartner";
import PageAddListing from "containers/PageAddListing/PageAddListing";
import PageOpenAdd from "containers/PageAddListing/OpenTrip/PageOpenAdd";
import PagePrivateAdd from "containers/PageAddListing/PrivateTrip/PagePrivateAdd";
import NcModal from "shared/NcModal/NcModal";
import { showUnderConstructionAlert } from "functions/redux/general/action";
import 'i18n/config';
import PageSearch from "containers/PageSearch/PageSearch";
import PageDetail from "containers/PageDetail/PageDetail";
import OrderDetail from "containers/PageDetail/OrderDetail";
import PageSearchByCountry from "containers/PageSearch/PageSearchByCountry";
import RecentOpenTrips from "containers/PageSearch/RecentOpenTrips";
import PageTermCondition from "../containers/PageHome/PageTermCondition";
import { getNotification } from "functions/redux/notification/action";
import PageNotification from "containers/PageProfile/PageNotification";
import RequestGuide from "containers/PageHome/RequestGuide";
import PageGiveaway from "containers/PageGiveaway/PageGiveaway";
import PageManageProducts from "containers/PageManageProducts/PageManageProducts";

export const AuthPages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/#", exact: true, component: PageHome },
  { path: "/search", component: PageSearch },
  { path: "/country-trips", component: PageSearchByCountry },
  { path: "/recent-open-trips", component: RecentOpenTrips },
  { path: "/detail", component: PageDetail },
  { path: "/booking-detail", component: OrderDetail },
  { path: "/profile", component: PageProfile },
  { path: "/join", component: PageJoinPartner },
  { path: "/term-and-condition", component: PageTermCondition },
  { path: "/privacy-policy", component: PageTermCondition },
  { path: "/cancelation-policy", component: PageTermCondition },
  { path: "/notification", component: PageNotification },
  { path: "/request-guide", component: RequestGuide },
  { path: "/giveaway", component: PageGiveaway },
];

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/#", exact: true, component: PageHome },
  { path: "/search", component: PageSearch },
  { path: "/country-trips", component: PageSearchByCountry },
  { path: "/recent-open-trips", component: RecentOpenTrips },
  { path: "/detail", component: PageDetail },
  { path: "/login", component: PageLogin, },
  { path: "/sign-up", component: PageSignUp },
  { path: "/join", component: PageLogin },
  { path: "/term-and-condition", component: PageTermCondition },
  { path: "/privacy-policy", component: PageTermCondition },
  { path: "/cancelation-policy", component: PageTermCondition },
  { path: "/request-guide", component: RequestGuide },
  { path: "/giveaway", component: PageGiveaway },

];

export const guidePages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/#", exact: true, component: PageHome },
  { path: "/profile", component: PageProfile },
  { path: "/search", component: PageSearch },
  { path: "/country-trips", component: PageSearchByCountry },
  { path: "/recent-open-trips", component: RecentOpenTrips },
  { path: "/detail", component: PageDetail },
  { path: "/add-listing", component: PageAddListing },
  { path: "/open-trip-add", component: PageOpenAdd },
  { path: "/booking-detail", component: OrderDetail },
  { path: "/private-trip-add", component: PagePrivateAdd },
  { path: "/term-and-condition", component: PageTermCondition },
  { path: "/privacy-policy", component: PageTermCondition },
  { path: "/cancelation-policy", component: PageTermCondition },
  { path: "/notification", component: PageNotification },
  { path: "/request-guide", component: RequestGuide },
  { path: "/giveaway", component: PageGiveaway },
  { path: "/manage-products", component: PageManageProducts },
];

const Routes = () => {
  const { user, general, notificationReducer } = useSelector((state: RootStore) => state);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (user.credential == null) {
      dispatch(getFullCreds());
    }
  }, [])

  React.useEffect(() => {
    if (user) {
      dispatch(getNotification());
    }
  }, [user, user.credential])


  return (
    <BrowserRouter>
      <NcModal
        isOpenProp={general.underConstruction.show}
        renderTrigger={() => { return (<div></div>); }}
        renderContent={() => { return general.underConstruction.content; }}
        onCloseModal={() => dispatch(showUnderConstructionAlert(false))}
        modalTitle={general.underConstruction.title}
      />
      <ScrollToTop />
      <Header credential={user.credential} notification={notificationReducer.notificationList} count={notificationReducer.notificationCount} />
      <Switch>
        {user.credential !== LOGIN_FALSE && user.credential !== null ?
          parseInt(user.credential.isGuide) === 1 ? guidePages.map(({ component, path, exact }) => {
            return (
              <Route
                key={path}
                component={component}
                exact={!!exact}
                path={path}
              />
            );
          }) :
            AuthPages.map(({ component, path, exact }) => {
              return (
                <Route
                  key={path}
                  component={component}
                  exact={!!exact}
                  path={path}
                />
              );
            })

          : pages.map(({ component, path, exact }) => {
            return (
              <Route
                key={path}
                component={component}
                exact={!!exact}
                path={path}
              />
            );
          })}
        {/* <Route component={Page404} /> */}
      </Switch>
      <Footer />
    </BrowserRouter>
  );
};

export default Routes;
